import React from "react";
import { objToFormData } from "../../../helpers/FormHelper";
import { createTip } from "../../../actions/mine_craft/tipsActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams, TipInterface } from "../../../store/mine_craft/tipsSlice";

import DrawerRight from "../../../componets/DrawerRight";
import AlertBlock from "../../../componets/AlertBlock";
import Form from './_partials/_Form';
import { AVAILABLE_LOCALES } from "../../../configs/constants";

const New = () => {
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.mineCraft.tips.newParams);
  const error     = useAppSelector(state => state.mineCraft.tips.newError);

  let params: any = { ...newParams };

  if (params) {
    params.title_translations = {};
    params.empty_locales      = Object.keys(AVAILABLE_LOCALES);
  }

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function getLocaleRules() {
    const localeRules: any = {};

    Object.keys(AVAILABLE_LOCALES).forEach(key => localeRules[key] = { blank: false });

    return localeRules;
  }

  function onFinish(data: TipInterface) {
    const rules     = { title_translations: getLocaleRules() };
    const formData  = objToFormData(data, rules);

    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createTip(data));

    if (createTip.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-tip'>
        <h6 className="v-content-label">Create Help</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        {params && <Form onFinish={onFinish} params={params} />}
      </div>
    </DrawerRight>
  )
}

export default New;
